import type {
  ISite,
  ISiteSystem,
  ISiteSystemEquipment,
  ISiteSystemsState,
  ISiteSystemType,
} from '@/Core.Service.Domain/Sites/SiteSystems/types/index.ts';

const siteSystems = (state: ISiteSystemsState): ISiteSystem[] =>
  state.siteSystems;

const siteSystem = (state: ISiteSystemsState): ISiteSystem | null =>
  state.siteSystem;

const siteSystemTypes = (state: ISiteSystemsState): ISiteSystemType[] =>
  state.siteSystemTypes;

const sitesForSelector = (state: ISiteSystemsState): ISite[] =>
  state.sitesForSelector;

const equipmentForSite = (state: ISiteSystemsState): ISiteSystemEquipment[] =>
  state.equipmentForSite;

const isSiteSystemsLoading = (state: ISiteSystemsState): boolean =>
  state.isSiteSystemsLoading;

const siteSystemSearchTerm = (state: ISiteSystemsState): string =>
  state.siteSystemSearchTerm;

export default {
  siteSystems,
  siteSystem,
  siteSystemTypes,
  sitesForSelector,
  equipmentForSite,
  isSiteSystemsLoading,
  siteSystemSearchTerm,
};
